import { render } from "./AboutContent.vue?vue&type=template&id=0a2b7483"
import script from "./AboutContent.vue?vue&type=script&lang=js"
export * from "./AboutContent.vue?vue&type=script&lang=js"

import "./AboutContent.vue?vue&type=style&index=0&id=0a2b7483&lang=css"
script.render = render

export default script